// consent.js
const KEY = 'consent-v2';

// --- utilities ---------------------------------------------------------------
const storageOK = (() => {
  try {
    if (typeof window === 'undefined') return false;
    localStorage.setItem('__t', '1');
    localStorage.removeItem('__t');
    return true;
  } catch {
    return false;
  }
})();

const dl = () => (window.dataLayer = window.dataLayer || []);

const mapToPayload = ({ analytics = false, ads = false, personalizedAds = false } = {}) => ({
  analytics_storage: analytics ? 'granted' : 'denied',
  ad_storage:        ads ? 'granted' : 'denied',
  ad_user_data:      ads ? 'granted' : 'denied',
  ad_personalization: personalizedAds ? 'granted' : 'denied',
});

// --- public API --------------------------------------------------------------
export const getConsent = () => {
  if (!storageOK) return null;
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
};

export const saveConsent = (value) => {
  if (!storageOK) return;
  const withMeta = { ...value, ts: Date.now() }; // keep when it was set
  localStorage.setItem(KEY, JSON.stringify(withMeta));
};

export const applyConsentToGtag = (v) => {
  const payload = mapToPayload(v || {});
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', payload);
  }
  // Let GTM react to changes either way
  dl().push({ event: 'consent_update', consent: v || {} });

  // Optional convenience: fire a one-off event for GA4 page_view-on-consent
  if (v?.analytics) dl().push({ event: 'consent_granted' });
};

export const setConsent = (value) => {
  saveConsent(value);
  applyConsentToGtag(value);
};

export const initConsentFromStorage = () => {
  const existing = getConsent();
  if (existing) applyConsentToGtag(existing);
};

export const clearConsent = () => {
  if (!storageOK) return;
  localStorage.removeItem(KEY);
  dl().push({ event: 'consent_reset' });
};
